<template>
  <div class="market-dropdown-wrapper">

    <!-- BUTTON -->
    <div class="selector-btn" @click="open">
      <span class="text-decoration-underline">{{ label }}</span>
      <v-icon small>mdi-chevron-down</v-icon>
    </div>

    <!-- MOBILE OVERLAY -->
    <div v-if="isOpen && isSmallScreen" class="overlay" @click="close"></div>

    <!-- DESKTOP DROPDOWN -->
    <transition name="fade">
      <div
          v-if="isOpen"
          class="dropdown-panel"
          :style="dropdownStyle"
          v-click-outside="close"
      >
        <div
            v-for="(event,i) in getGroupedEvents"
            :key="event.id"
            class="dropdown-item"
            :class="event.id === id ? 'active' : ''"
            @click="goToEventDetail(event)"
        >
          <div class="tournament">
            <img class="img-flag-filter" :src="categoryPath + event.categoryId + '.svg'" :alt="event.categoryName" @error="handleImgError">
            {{event.tournamentName}}
          </div>
          <div class="item">
            <div class="comp">
              <div class="home"><LogoCompetitors height="16px" width="auto" :team-id="event.home_id"/><span>{{ event.home }}</span></div>
              <div class="away"><LogoCompetitors height="16px" width="auto" :team-id="event.away_id"/><span>{{ event.away }}</span></div>
              <span class="info-match">{{ getInfoTimeMatch(event.livescore, event.sportId, event.status) }}</span>
            </div>
            <div class="results">
              <span>{{ genericScore(event.livescore, 'home') }}</span>
              <span>{{ genericScore(event.livescore, 'away') }}</span>
              <span class="time-info" v-if="event.livescore.scoreboard.time != '-1' && event.livescore.scoreboard.time != '0'">
              {{ getMatchCurrentTime(event.livescore.scoreboard.time) }}<span class="blink_me">'</span>
            </span>
            </div>
          </div>


        </div>
      </div>
    </transition>

    <!-- MOBILE BOTTOM SHEET -->
<!--    <transition name="sheet">-->
<!--      <div v-if="isOpen && isSmallScreen" class="mobile-sheet">-->

<!--        &lt;!&ndash; overlay &ndash;&gt;-->
<!--        <div class="overlay" @click="close"></div>-->

<!--        &lt;!&ndash; panel &ndash;&gt;-->
<!--        <div class="sheet-panel">-->
<!--          <div class="drag-bar"></div>-->

<!--          <div class="sheet-list">-->
<!--            <div-->
<!--                v-for="(event,i) in getGroupedEvents"-->
<!--                :key="i"-->
<!--                class="sheet-item"-->
<!--                :class="event.id === id ? 'active' : ''"-->
<!--                @click="goToEventDetail(event)"-->
<!--            >-->
<!--              <div class="tournament">-->
<!--                <img class="img-flag-filter" :src="categoryPath + event.categoryId + '.svg'" :alt="event.categoryName" @error="handleImgError"> {{event.tournamentName}}-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="comp">-->
<!--                  <div class="home"><LogoCompetitors height="16px" width="auto" :team-id="event.home_id"/><span>{{ event.home }}</span></div>-->
<!--                  <div class="away"><LogoCompetitors height="16px" width="auto" :team-id="event.away_id"/><span>{{ event.away }}</span></div>-->
<!--                  <span class="info-match">{{ getInfoTimeMatch(event.livescore, event.sportId, event.status) }}</span>-->

<!--                </div>-->
<!--                <div class="results">-->
<!--                  <span>{{ genericScore(event.livescore, 'home') }}</span>-->
<!--                  <span>{{ genericScore(event.livescore, 'away') }}</span>-->
<!--                  <span class="time-info" v-if="event.livescore.scoreboard.time != '-1' && event.livescore.scoreboard.time != '0'">-->
<!--                  {{ getMatchCurrentTime(event.livescore.scoreboard.time) }}<span class="blink_me">'</span>-->
<!--                </span>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </div>-->


<!--    </transition>-->

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import LogoCompetitors from "@/components/center_widgets/LogoCompetitors.vue";

export default {
  name: "QuickSelectEventLive",
  components: {LogoCompetitors},
  props: {
    items: Array,
    value: Object,
    isMobile: Boolean,
    label: String,
    id: String
  },
  emits: ['isLoading'],

  data() {
    return {
      isOpen: false,
      isSmallScreen: false,
      categoryPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/categories/round_flags/',
      buttonRect: null,
    }
  },

  computed: {
    ...mapGetters({
      'getPreviewLive': 'previewLive/getPreviewLive'
    }),
    getGroupedEvents() {
      let events = this.getPreviewLive.events.flat()
      return events.filter(e => e.id !== this.id).slice(0, 20)
    },
    dropdownStyle() {
      if (!this.buttonRect) return {};

      if(this.isSmallScreen)
        return{
          top: this.buttonRect.bottom + 'px',
          right: '10px',
        }
      return {
        top: this.buttonRect.bottom + 'px',
        left: this.buttonRect.left + 'px',
      };
    },
  },
  async mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    ...mapActions({
      'fetchEventLiveDetail': 'detailLive/fetchEventLiveDetailV5'
    }),
    handleImgError(e) { e.target.style.display = 'none'; },
    getMatchCurrentTime(time) {
      if (time === undefined || time === null || time === '') return '';
      const timeNum = parseInt(time, 10);
      if (isNaN(timeNum) || timeNum < 0) return '';
      var minutes = Math.floor(timeNum / 60);
      var seconds = timeNum - minutes * 60;
      return (seconds < 10) ? minutes + ':0' + seconds : minutes + ':' + seconds;
    },
    getInfoTimeMatch(livescore, sport, status) {
      // Check livescore first: it's updated by socket and reflects the true in-play state.
      if (status === '9' || livescore.scoreboard.currentPeriod === '-1') { return this.$t('periods.about_to_start'); }

      if (livescore && livescore.scoreboard && livescore.scoreboard.currentPeriod) {
        return this.$t('periods.' + sport + '.' + livescore.scoreboard.currentPeriod);
      }

      return '';
    },
    onResize() {
      const w = window.innerWidth;

      this.isSmallScreen = w <= 600;

    },
    goToEventDetail(event) {
      this.getDetailOfEventLive(event.id, event.type, event.sportId, (event.tournamentId) ? event.tournamentId : '', event.status);
    },
    async getDetailOfEventLive(eventSource, type, sport, tournament, status) {
      this.close()
      this.loading = true;
      this.$root.$emit('isloading_quick_select_event_live', true)
      await this.fetchEventLiveDetail({ 'source': eventSource, 'group': 0, 'sport': sport, 'tournament': tournament, 'status': status });
      this.loading = false;
      this.$root.$emit('isloading_quick_select_event_live', false)


    },
    genericScore(livescore, position) {
      // FIX CRITICO: Controlla tutta la catena prima di accedere
      if (!livescore || !livescore.scoreboard || !livescore.scoreboard.results) {
        return { home: '-', away: '-' };
      }

      const results = livescore.scoreboard.results;
      if(position === 'home')
        return results.find(r => r.position === '1')?.value ?? '0'
      else
        return results.find(r => r.position === '2')?.value ?? '0'

    },
    open() {
      const btn = this.$el.querySelector('.selector-btn');
      this.buttonRect = btn ? btn.getBoundingClientRect() : null;
      this.isOpen = true
      document.body.classList.add("no-scroll")
      const stickyNav = this.$el.closest('.sticky-nav');
      if (stickyNav) { stickyNav.style.zIndex = '10000'; stickyNav.style.position = 'sticky'; }
    },
    close() {
      this.isOpen = false
      document.body.classList.remove("no-scroll")
      const stickyNav = this.$el.closest('.sticky-nav');
      if (stickyNav) {
        setTimeout(() => { stickyNav.style.zIndex = ''; stickyNav.style.position = ''; }, 250);
      }
    },
    select(item) {

      // this.close()
    }
  }
}
</script>

<style scoped>



.selector-btn{
  border-radius: 6px;
  padding: 0 10px;
  font-weight: 700;
  display:flex;
  align-items:center;
  gap:6px;
  cursor:pointer;
  min-height: 44px;
  touch-action: manipulation;
}
.selector-btn:active { opacity: 0.75; }
.selector-btn span{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-panel{
  position: fixed;
  width: 260px;
  max-height: 320px;
  overflow-y: auto;
  overscroll-behavior: contain !important;
  background: var(--bg-card-gradient-to-r);
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,.4);
  padding: 8px;
  z-index: 9999;
}

.dropdown-item{
  padding:10px;
  cursor:pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: space-between;
  border-radius: 4px;
  border-bottom: 1px solid var(--border-color);
  min-height: 44px;
  touch-action: manipulation;
  transition: background 0.15s ease
}
.dropdown-item:active { background: var(--bg-cell); }
.dropdown-item .item{
  display: flex;
  justify-content: space-between;
}
.dropdown-item .tournament{
  font-size: var(--font-size-xl);
  color: var(--text-op-50-platform);
  display: flex;
  align-items: center;
  gap: 4px;
}
.dropdown-item .comp{
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: bolder;
  max-width: 86%;

}

.dropdown-item .comp span{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown-item .results{
  display: flex;
  flex-direction: column;
  text-align: right;
  gap: 4px;
  font-weight: bolder;
  color: var(--color-secondary);
}


.dropdown-item.active{
  background: var(--bg-cell);
}

.dropdown-item:hover{
  background: var(--bg-cell-hover);
}

/* MOBILE */
.mobile-sheet{
  position:fixed;
  inset:0;
  z-index:999;
}

.overlay{
  position:absolute;
  inset:0;
  background: var(--modal-overlay);
  backdrop-filter: blur(1px);
}

.sheet-panel{
  position:absolute;
  bottom:0;
  left:0;
  right:0;
  background: var(--bg-panel);
  border-radius:16px 16px 0 0;
  padding:16px;
  max-height:72vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}


.sheet-item{
  padding:14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-color);
  min-height: 44px;
  touch-action: manipulation;
}
.sheet-item:active { background: var(--bg-cell); }

.sheet-item .item{
  display: flex;
  justify-content: space-between;
}
.sheet-item .tournament{
  font-size: var(--font-size-xl);
  color: var(--text-op-50-platform);
  display: flex;
  align-items: center;
  gap: 4px;
}
.sheet-item.active{
  background: var(--primary-color);
}
.sheet-item .comp{
  display: flex;
  flex-direction: column;
  text-align: left;
  font-weight: bolder;
}
.sheet-item .results{
  display: flex;
  flex-direction: column;
  text-align: right;
  font-weight: bolder;
}

/* animazioni */
.fade-enter-active,
.fade-leave-active{transition:.2s}
.fade-enter{opacity:0}

.sheet-enter-active{
  transition:.25s;
}
.sheet-enter .sheet-panel{
  transform:translateY(100%);
}
.sheet-enter-to .sheet-panel{
  transform:translateY(0);
}



.drag-bar {
  width: 48px;
  height: 5px;
  background: var(--text-op-50-platform);
  opacity: 0.5;
  border-radius: 3px;
  margin: 10px auto 8px;
}

.info-match{  color: var(--color-accent);border-radius:4px;font-size: var(--font-size-xl);text-transform: uppercase;font-weight: bolder;line-height: 18px;}
.time-info{
  font-weight: lighter;
  font-size: var(--font-size-md);text-transform: uppercase;line-height: 18px;
  color: var(--text-platform);
}

.comp .home, .comp .away{display: flex; align-items: center; gap: 4px}
.comp .home img, .comp .away img{height: 16px;}

@media (max-width: 600px) {
  .dropdown-panel{
    width: calc(100% - 20px)
  }
}

.overlay {
  position: fixed;      /* no absolute, serve per desktop */
  inset: 0;
  background: rgba(0,0,0,0.3); /* o la tua var(--modal-overlay) */
  z-index: 9998;
  cursor: pointer;
}
.img-flag-filter{
  width: 20px;
  margin-right: 5px !important;
}
</style>